import React, { FC } from 'react';
import { LinkResponseDto } from '../../../store/landscapeAPI/link/dto/response/link-response.dto';
import { Action, Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';

//import styles from './LandscapeIndicatorExternalResourcesOrganism.module.css';

interface LandscapeIndicatorExternalResourcesOrganismProps {
  data: LinkResponseDto[];
  handleDeleteLink: (id: string) => void;
  handleUpdateLink: (resourceId: string) => void;
}

const LandscapeIndicatorExternalResourcesOrganism: FC<
  LandscapeIndicatorExternalResourcesOrganismProps
> = ({ data, handleDeleteLink, handleUpdateLink }) => {
  return (
    <SortableTable
      data={data}
      columns={[
        { label: 'Goals', key: 'title' },
        { label: 'Type', key: 'url' },
      ]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.title}></Label>
          <Label content={row.url}></Label>

          <Action
            type="edit"
            size="sm"
            onClick={() => handleUpdateLink(row.id)}
          ></Action>
          <Action
            type="delete"
            itemName={row.title}
            size="sm"
            onClick={() => handleDeleteLink(row.id)}
          ></Action>
        </TableRow>
      )}
    />
  );
};

export default LandscapeIndicatorExternalResourcesOrganism;
